module.exports = __webpack_public_path__ + "static/android_6_EN-6c88441d422a2c510e59e7159c1237f4.jpg";